import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-83e9cd3e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "message_main_wrap" }
const _hoisted_2 = { class: "message_main" }
const _hoisted_3 = { class: "message_avatar" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "message_content" }
const _hoisted_6 = { class: "user_name" }
const _hoisted_7 = { class: "name" }
const _hoisted_8 = {
  key: 0,
  class: "nameplate offical"
}
const _hoisted_9 = {
  key: 1,
  class: "nameplate up"
}
const _hoisted_10 = { class: "time" }
const _hoisted_11 = {
  key: 0,
  class: "message_img_wrap"
}
const _hoisted_12 = {
  key: 1,
  class: "message_gift_wrap"
}
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "mrew_cover" }
const _hoisted_15 = { class: "mrew_cover_text" }
const _hoisted_16 = { class: "mrew_cover_img" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "mrew_title" }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = { class: "message_comment" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "comment_item_txt" }, "回复", -1))
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "comment_item_txt mod_ellip" }
const _hoisted_24 = {
  key: 4,
  class: "hidden_txt"
}
const _hoisted_25 = {
  key: 5,
  class: "hidden_txt"
}
const _hoisted_26 = {
  key: 6,
  class: "message_ip"
}
const _hoisted_27 = {
  class: "comment_action_group_item",
  "data-key": 0
}
const _hoisted_28 = {
  key: 0,
  class: "comment_action_group_item",
  "data-key": 1
}
const _hoisted_29 = {
  key: 1,
  class: "comment_action_group_item",
  "data-key": 2
}
const _hoisted_30 = ["data-clipboard-text"]
const _hoisted_31 = {
  key: 3,
  class: "comment_action_group_item",
  "data-key": 4
}
const _hoisted_32 = {
  key: 4,
  class: "comment_action_group_item",
  "data-key": 5
}
const _hoisted_33 = {
  key: 5,
  class: "comment_action_group_item",
  "data-key": 6
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "comment_action_group_item",
  "data-key": 7
}, "删除", -1))
const _hoisted_35 = { class: "comment_info" }
const _hoisted_36 = {
  key: 0,
  class: "message_child_box"
}
const _hoisted_37 = { class: "message_avatar" }
const _hoisted_38 = ["src"]
const _hoisted_39 = { class: "message_content" }
const _hoisted_40 = { class: "user_name" }
const _hoisted_41 = { class: "name" }
const _hoisted_42 = { class: "comment_action" }
const _hoisted_43 = ["innerHTML"]
const _hoisted_44 = {
  key: 0,
  class: "hidden_txt"
}
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { class: "message_avatar" }
const _hoisted_47 = ["src"]
const _hoisted_48 = { class: "message_content comment_container" }
const _hoisted_49 = { class: "user_name" }
const _hoisted_50 = { class: "name" }
const _hoisted_51 = { class: "comment_action" }
const _hoisted_52 = ["innerHTML"]
const _hoisted_53 = {
  key: 0,
  class: "hidden_txt"
}
const _hoisted_54 = {
  key: 1,
  class: "message_child_btn"
}

import { withDefaults, ref, reactive, computed, createVNode, onMounted, onUnmounted, watch } from 'vue';
import { message, Popconfirm, Spin, Popover } from 'ant-design-vue';
import { LoadingOutlined } from '@ant-design/icons-vue';
import { ElImage } from 'element-plus';
import { formatEmoji, GroupChat, MsgComment } from '@/pinia/types/console';
import { LightGiftContent, RedEnvelopeContent } from '@/pinia/types/livechat';
import { LuckMoney, Packet, Prize } from '@/assets';
import ClipboardJS from 'clipboard';
import http from '@/api';
import EventBus from '@/components/EventBus';
import { useConsoleStore } from '@/pinia/console';

interface Props {
  sourceData: GroupChat;
  self: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GroupMsgItem',
  props: {
    sourceData: null,
    self: { type: Boolean, default: true }
  },
  emits: ['update:setLike', 'click:setEditUser', 'click:openPacket', 'click:onCommentUser'],
  setup(__props: any, { emit }) {

const props = __props as { sourceData: GroupChat, self: boolean };

const aPopconfirm = Popconfirm;
const aSpin = Spin;
const elImage = ElImage;
const aPopover = Popover;
const consoleStore = useConsoleStore();


const data = reactive(props.sourceData);

const PacketUrl = computed(() => {
  if ((data.content as RedEnvelopeContent).type === 4 && (data.content as RedEnvelopeContent)?.contest_type === '2') {
    return Prize;
  } else if ((data.content as RedEnvelopeContent).type === 4) {
    return LuckMoney;
  } else {
    return Packet;
  }
});
const PacketClassName = computed(() => ((data.content as RedEnvelopeContent).type === 4 ? 'luck_style' : 'packet_style'));


// 点赞
const onClickLike = () => {
  emit('update:setLike');
};

const onClickMsgEdit = (event: Event) => {
  const keyIndex = parseInt((event.target as HTMLInputElement).dataset.key as string);
  if (keyIndex === 3) return;
  const formData = {
    key: keyIndex,
    data: data,
  };
  emit('click:setEditUser', formData);
};
const onClickCmntEdit = (commentData: MsgComment, keyIndex: number) => {
  const commentIdArr = data.comment
    .map((obj) => {
      return obj.comment_msg_id;
    })
    .join(',')
    .split(',');
  const formData = {
    key: keyIndex,
    data: {
      msg_id: commentData.comment_msg_id,
      status: commentData.comment_status,
      avatar: commentData.comment_uid,
      nickname: commentData.comment_nickname,
      uid: commentData.comment_uid,
      group_msg_id: data.msg_id,
      staticData: !commentIdArr.includes(commentData.comment_msg_id),
    },
  };
  emit('click:setEditUser', formData);
};

const onDelMsg = (keyIndex: number) => {
  const formData = {
    key: keyIndex,
    data: data,
  };
  emit('click:setEditUser', formData);
};
const messageRef = ref();
const textCopy = ref();
const onCopyTxt = (event: Event, className: string) => {
  const ClipboardJSObj = new ClipboardJS(className);
  const formatStr = messageRef.value.innerHTML.replaceAll('<br><br>', '\n').replaceAll('<br>', '\n');
  textCopy.value = formatStr.replace(
    /<img [^>]*class="emoji" [^>]*alt=['"]([^'"]+)[^>]*>/gi,
    (match: any, capture: any) => capture
  );
  ClipboardJSObj.on('success', (e) => {
    message.destroy();
    message.info('复制成功');
    e.clearSelection();
  });
  ClipboardJSObj.on('error', () => {
    message.destroy();
    message.info('复制失败');
  });
};

const indicator = createVNode(LoadingOutlined, {
  style: {
    fontSize: '18px',
  },
  spin: true,
});
const loading = ref(false);
const isShow = ref(false);
const list = ref<MsgComment[]>([]);
const pageConfig = reactive({
  current: 0,
  page_num: 10,
  total: 0,
});
const updateList = (visible = true) => {
  if (list.value.length !== 0 && !isShow.value && data.comment.length !== 0) {
    isShow.value = true;
    return;
  }
  const commentIdArr = data.comment
    .map((obj) => {
      return obj.comment_msg_id;
    })
    .join(',')
    .split(',');
  loading.value = true;
  http.liveChat
    .getMoreComment({
      params: {
        msg_id: data.msg_id,
        page: pageConfig.current + 1,
        page_num: pageConfig.page_num,
      },
    })
    .then((res) => {
      const resData = res.data.data;
      pageConfig.current = resData.current_page;
      pageConfig.total = resData.total;
      const arr: MsgComment[] = [];
      resData.data.forEach((e: MsgComment) => {
        if (commentIdArr.includes(e.comment_msg_id)) {
          return false;
        }
        e.comment_content = formatEmoji(e.comment_content);
        arr.push(e);
      });
      list.value = list.value.concat(arr);
    })
    .finally(() => {
      loading.value = false;
      isShow.value = visible;
    });
};

/**
 * 评论收起
 */
const onPack = () => {
  isShow.value = false;
  if (data.comment.length === 0) return;
  list.value = [];
  pageConfig.current = 0;
  pageConfig.total = 0;
};

watch(
  () => data.comment.length,
  async (newVal, oldVal) => {
    if (newVal !== 0 || newVal > oldVal) return;
    onPack();
    await updateList(isShow.value);
  }
);

/**
 * 监听评论的数据更新： 评论由（ 实时评论与数据库评论组成 ）
 * 由于加载的列表是当前页面请求的数据故监听删除的回调再处理
 * @param sourceData
 */
const updateComment = function <T>(sourceData: T) {
  if (!sourceData['group_msg_id'] || sourceData['group_msg_id'] !== data.msg_id) return;
  const findIndex = list.value.findIndex((e) => e.comment_msg_id === sourceData['comment_msg_id']);
  list.value[findIndex].comment_status = sourceData['status'];
};
/**
 * 监听评论的删除： 评论由（ 实时评论与数据库评论组成 ）
 * 由于加载的列表是当前页面请求的数据故监听删除的回调再处理
 * @param sourceData
 */
const delComment = function <T>(sourceData: T) {
  if (!sourceData['group_msg_id'] || sourceData['group_msg_id'] !== data.msg_id) return;
  const newArr = list.value.filter((e) => e.comment_msg_id !== sourceData['comment_msg_id']);
  list.value = newArr;
};

onMounted(() => {
  EventBus.on('updateComment', updateComment);
  EventBus.on('delComment', delComment);
});
onUnmounted(() => {
  EventBus.off('updateComment', updateComment);
  EventBus.off('delComment', delComment);
});

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: data.avatar_url,
          alt: ""
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(data.nickname), 1),
          (data.level)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, "官方"))
            : _createCommentVNode("", true),
          (data.top_status)
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, "置顶"))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_10, _toDisplayString(data.created_at), 1)
        ]),
        (data.msg_type === 'img')
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(_unref(elImage), {
                src: data.image_content_url,
                "preview-src-list": [data.image_content_url as string],
                "hide-on-click-modal": "",
                teleported: ""
              }, null, 8, ["src", "preview-src-list"])
            ]))
          : (data.msg_type === 'gift')
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createTextVNode(" 送了" + _toDisplayString((data.content as LightGiftContent).title), 1),
                _createElementVNode("img", {
                  src: (data.content as LightGiftContent).image_url,
                  alt: ""
                }, null, 8, _hoisted_13),
                _createTextVNode(" x " + _toDisplayString((data.content as LightGiftContent).number), 1)
              ]))
            : (data.msg_type === 'redpack')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: _normalizeClass(["message_red_envelope_wrap", _unref(PacketClassName)]),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click:openPacket', data.content)))
                }, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, _toDisplayString((data.content as RedEnvelopeContent).command), 1),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("img", {
                        src: _unref(PacketUrl),
                        alt: ""
                      }, null, 8, _hoisted_17)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_18, _toDisplayString((data.content as RedEnvelopeContent).type_name), 1)
                ], 2))
              : (_openBlock(), _createElementBlock("div", {
                  key: 3,
                  innerHTML: data.content,
                  ref_key: "messageRef",
                  ref: messageRef,
                  class: "message_txt"
                }, null, 8, _hoisted_19)),
        _createElementVNode("div", _hoisted_20, [
          (!props.self)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "comment_item",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('click:onCommentUser', data)))
              }, [
                _createVNode(_component_svg_icon, { "icon-class": "msg_comment" }),
                _hoisted_21
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_22)),
          _createElementVNode("div", {
            class: _normalizeClass(["comment_item", { liked: data.like === 1 }]),
            onClick: onClickLike
          }, [
            _createVNode(_component_svg_icon, { "icon-class": "msg_likes" }),
            _createElementVNode("span", _hoisted_23, _toDisplayString(data.like_num), 1)
          ], 2)
        ]),
        (data.status === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _createVNode(_component_svg_icon, {
                class: "icon",
                "icon-class": "msg_hide"
              }),
              _createTextVNode("隐藏中...")
            ]))
          : _createCommentVNode("", true),
        (data.status === 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _createVNode(_component_svg_icon, {
                class: "icon",
                "icon-class": "msg_hide"
              }),
              _createTextVNode("敏感词隐藏中...")
            ]))
          : _createCommentVNode("", true),
        (_unref(consoleStore).consoleInfo.addressStatus && data.address)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createVNode(_component_svg_icon, { "icon-class": "console_address" }),
              _createTextVNode(_toDisplayString(data.address), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", {
      class: "comment_action_group",
      onClick: onClickMsgEdit
    }, [
      _createElementVNode("div", _hoisted_27, _toDisplayString(data.status === 1 ? '隐藏' : '通过'), 1),
      (data.msg_type === 'txt')
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, "弹幕"))
        : _createCommentVNode("", true),
      (['txt', 'img', 'redpack'].includes(data.msg_type))
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(data.top_status ? '取消置顶' : '置顶') + " ", 1))
        : _createCommentVNode("", true),
      (data.msg_type === 'txt')
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "comment_action_group_item copy_body",
            "data-key": 3,
            "data-clipboard-text": textCopy.value,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (onCopyTxt($event, '.copy_body')))
          }, " 复制 ", 8, _hoisted_30))
        : _createCommentVNode("", true),
      (!props.self)
        ? (_openBlock(), _createElementBlock("div", _hoisted_31, "禁言"))
        : _createCommentVNode("", true),
      (!props.self)
        ? (_openBlock(), _createElementBlock("div", _hoisted_32, "拉黑"))
        : _createCommentVNode("", true),
      (!props.self)
        ? (_openBlock(), _createElementBlock("div", _hoisted_33, "私聊"))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "comment_action_btn",
        onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
      }, [
        _createVNode(_unref(aPopconfirm), {
          title: "确定删除这条消息吗？",
          "ok-text": "确定",
          "cancel-text": "取消",
          onConfirm: _cache[3] || (_cache[3] = ($event: any) => (onDelMsg(7)))
        }, {
          default: _withCtx(() => [
            _hoisted_34
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_35, [
      (data.comment.length > 0 || list.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.comment, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.comment_id,
                class: "message_main"
              }, [
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("img", {
                    src: item.comment_avatar_url,
                    alt: ""
                  }, null, 8, _hoisted_38)
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("span", _hoisted_41, _toDisplayString(item.comment_nickname), 1),
                    _createElementVNode("div", _hoisted_42, [
                      _createVNode(_unref(aPopover), null, {
                        content: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.comment_status ? '隐藏' : '通过'), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, {
                            class: "action_btn",
                            type: "text",
                            size: "small",
                            onClick: ($event: any) => (onClickCmntEdit(item, 0))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_svg_icon, {
                                "icon-class": item.comment_status ? 'control_comment_hide' : 'control_comment_pass'
                              }, null, 8, ["icon-class"])
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_unref(aPopover), null, {
                        content: _withCtx(() => [
                          _createTextVNode("拉黑")
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, {
                            class: "action_btn",
                            type: "text",
                            size: "small",
                            onClick: ($event: any) => (onClickCmntEdit(item, 5))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_svg_icon, { "icon-class": "control_comment_cancelled" })
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_unref(aPopover), null, {
                        content: _withCtx(() => [
                          _createTextVNode("删除")
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_unref(aPopconfirm), {
                            title: "确定删除这条评论吗？",
                            "ok-text": "确定",
                            "cancel-text": "取消",
                            onConfirm: ($event: any) => (onClickCmntEdit(item, 7))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_button, {
                                class: "action_btn",
                                type: "text",
                                size: "small"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_svg_icon, { "icon-class": "control_comment_del" })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1032, ["onConfirm"])
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]),
                  _createElementVNode("div", {
                    innerHTML: item.comment_content,
                    class: "message_txt"
                  }, null, 8, _hoisted_43),
                  (item.comment_status === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                        _createVNode(_component_svg_icon, {
                          class: "icon",
                          "icon-class": "msg_hide"
                        }),
                        _createTextVNode("隐藏中... ")
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128)),
            (isShow.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (msgItem) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: msgItem.comment_msg_id,
                      class: "message_main"
                    }, [
                      _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("img", {
                          src: msgItem.comment_avatar_url,
                          alt: ""
                        }, null, 8, _hoisted_47)
                      ]),
                      _createElementVNode("div", _hoisted_48, [
                        _createElementVNode("div", _hoisted_49, [
                          _createElementVNode("span", _hoisted_50, _toDisplayString(msgItem.comment_nickname), 1),
                          _createElementVNode("div", _hoisted_51, [
                            _createVNode(_unref(aPopover), null, {
                              content: _withCtx(() => [
                                _createTextVNode(_toDisplayString(msgItem.comment_status ? '隐藏' : '通过'), 1)
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_a_button, {
                                  class: "action_btn",
                                  type: "text",
                                  size: "small",
                                  onClick: ($event: any) => (onClickCmntEdit(msgItem, 0))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_svg_icon, {
                                      "icon-class": msgItem.comment_status ? 'control_comment_hide' : 'control_comment_pass'
                                    }, null, 8, ["icon-class"])
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_unref(aPopover), null, {
                              content: _withCtx(() => [
                                _createTextVNode("拉黑")
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_a_button, {
                                  class: "action_btn",
                                  type: "text",
                                  size: "small",
                                  onClick: ($event: any) => (onClickCmntEdit(msgItem, 5))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_svg_icon, { "icon-class": "control_comment_cancelled" })
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_unref(aPopover), null, {
                              content: _withCtx(() => [
                                _createTextVNode("删除")
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_unref(aPopconfirm), {
                                  title: "确定删除这条评论吗？",
                                  "ok-text": "确定",
                                  "cancel-text": "取消",
                                  onConfirm: ($event: any) => (onClickCmntEdit(msgItem, 7))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_button, {
                                      class: "action_btn",
                                      type: "text",
                                      size: "small"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_svg_icon, { "icon-class": "control_comment_del" })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 2
                                }, 1032, ["onConfirm"])
                              ]),
                              _: 2
                            }, 1024)
                          ])
                        ]),
                        _createElementVNode("div", {
                          innerHTML: msgItem.comment_content,
                          class: "message_txt"
                        }, null, 8, _hoisted_52),
                        (msgItem.comment_status === 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                              _createVNode(_component_svg_icon, {
                                class: "icon",
                                "icon-class": "msg_hide"
                              }),
                              _createTextVNode("隐藏中... ")
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              _withDirectives(_createVNode(_unref(aSpin), { indicator: _unref(indicator) }, null, 8, ["indicator"]), [
                [_vShow, loading.value]
              ])
            ]),
            (!loading.value && (data.comment.length > 0 || list.value.length > 0))
              ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                  (pageConfig.total !== data.comment.length + list.value.length || !isShow.value)
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 0,
                        type: "link",
                        onClick: updateList
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("查看更多评论>>")
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_a_button, {
                        key: 1,
                        class: "message_child_a",
                        type: "link"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("没有更多评论了")
                        ]),
                        _: 1
                      })),
                  (pageConfig.total > 0 && isShow.value)
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 2,
                        type: "link",
                        class: "message_child_btn_unflod",
                        onClick: onPack
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("收起")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})